export const BACKEND_URL = "usa.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "aa6af77571b1b75d6c202ab59f3e63245e978b0a1fe1d405f7941f215fd14e2fc32b1430da902cfac3f9ddd2d420d1d7171132e4c36ac86858508e5edbf58f7f5b333d652f06f70868fcf83d77172c6921d8f2d06098f5b6372259fa3f6b5ebe";
export const CERTIFICATE_MODE = "vrf" as const;
export const PARTICIPANTS: string[] = [
    "0b722725f00c2faf0f79679604da41e9ff2809e088aed10045c5adeb8c61fc34",
    "0ca5ee7ddf9bdc8288211757f61dcc02093856bf4c676da8e246d8366d9db566",
    "0e7e9698a59a705d6b39f99df337b78152eacccd24a72216e58f76a2daba9869",
    "120e09c2ea90a67a708cbc85720991e1909ce7dd567c627cf1079e8098c17424",
    "131498936b185dc5d18a65d10009f43ef7a3ceeff184ab2bf70027efea1acec4",
    "24f04012c319427d6d763cda154d588a9003544d7ccd16d62938726982e8f157",
    "2bff47aa934167b8f15076135c2552d5811f13c16e6a940ac0a43b36075f85c2",
    "3309b6f4dbf2b8d73583ce3d336cf75b5e6c069e34ffa59b1e9f082546c74ef0",
    "35be3f09f434cf30099f3c44f08c8348932b0034586f3c72012019be9b73810b",
    "3774ff4a3bf0da90a0e135bf02b9b8dc2bbfb76a5ddaab4cdfe105079f9098ca",
    "3ba075b2303de582521804c003f0bb994e87cd9dfee925ec730dddef2c0f3543",
    "52494c46669d4153abea67d7979e191291a1ecded5a6e9b9d717429400902b3b",
    "58f88969c35e1a6d14f5f9180099949ab44dcbc4dcb30f662af1a77da47fa5f1",
    "62b9e850ffcb27af17969ff5e235cea474bb60a48f6e4ec52c9147d00711caec",
    "646e973e973e4d1c7421a6e0636833ea75e1ddc848e194f5cb48129e1bcc960f",
    "64bae18a37fb15783d44b790e12d41d6c3e34cb419974a45cc15d21e03bb9d60",
    "67a615f83628dfd5375e227614372a99b14486dda58825fbf5967e401741b5e9",
    "6ba148dfcb30c2585d2818dbf96857e3a0591002fcf0f243d5b6a3ba94bb16e0",
    "6bff0fff137c9ef6c1d466197635cab5d7646f8489c028b92265e369aed75814",
    "7c426b244fa843fffd821faadb69d15bb11d6196a560744436487f77d12cf6b1",
    "8145c250a394070ea6d20cd278723df98e9d2e10a9fedb1ffa3bc4051da09493",
    "81e369cb41841b6790c92a6f130f5ff2bed9f3f51eea405a7e9c8ebf9e64c509",
    "88d6a3f7c0c7dca0917d863e91bb32ed18ed62ec5f1da3940467c3fbe23d7229",
    "8925d4816efea54deb467c0a2cb67be378924bc0fadcc4bb82f2ec1f581cd30e",
    "8dc2085bf27c250bf674a823f298b2c58d27a57069866a0b284bb8b62e1c5bcf",
    "8fc5e9271d784f305c22825a63c1b621cd9dcfd11aa748d062c1e5801af43ab8",
    "980f5ffd8e047e91b721d820a1387b970911ab5aa8f3263686a16f2221a6b428",
    "9a3254c76cae135464ca4b6dcf96f7bafcc02cd3c09af141c02119f72531d674",
    "9ac686270c89fafd156cd1043da4001d60fd000b5ecdb53baecf3e2b17370e26",
    "a0eda82f530bd530847b3b6c7c6edd83f679045f58e214b264af6e4ee3d5fde1",
    "a761cb05b491550001b95f87d724e7f8ff81f45b935fc463210a82ea47103da7",
    "a829c4374d69dd81bfa35a73d81bd475f136c3ac08e4ab39a7eda80d0ab21cd4",
    "b2d95ad020743cd8343cf78a32b9ef8b3d5884d89a3f6d928f047e5b931f23af",
    "bb517560401803e03b95acd954ccea8aa78da3f799eefe22d11593ca66248b26",
    "bfb1a717a8eeb40d7d201d25a38140bbbb22ecb6cf10334a99187451c878b87e",
    "c0d1637179c25326e79ad4cf5e7c17d68fed69b08d61968c93d6b3513dbadb0d",
    "c21674b216ec4d6c1568de903f2aaaf03887f7752c89ddb6f0cea5cfe7d2ff05",
    "c9a471cef7d4b652ec3e6df2625b3cc3c9a666416574d027969afafc77e09759",
    "c9bddf6907cdf254b39ec5f811952fdd54aea8e9b32e3616c5222768fc2547d2",
    "cdd0d57dce98bfaff16e94b9b7cd4bde00bf1e3e226389a8aef22a2f9e976a49",
    "ce529c9cf42e32c8acd0c347a4c7963e14cedbae73156f44420e2e260646f9e0",
    "dc1d32786f40f51183c7d4c138cb0b601d232d4a30d1776d4303fadd2ad06421",
    "e22db6daded162f58a533f3fffc0bd303958147f98b935f832eb0a3d62a63540",
    "e76d3811267b69cc9c762756db153eb86f207f79468eff20e8f4cad990f26565",
    "ec5067962fc847b5d6281c91a9786399cacff84fa934f8b29f2521e9b6377346",
    "ed64a9cffb16d5b5f4106c08a87ff9f6776e7be66111134b68e7689d2f240bef",
    "f88f233fb1e339d36f81d414e711530f89752d03d00adcc4cb9dd174e8da9d25",
    "fa61376a4c243ce5749a429f4255e0e80574f6da562bc516d0ce94489b9215a8",
    "fd914c06ea816638022c74f8cbbc69968ca2c4bc2c01ba38b3da076ff6f632bb",
    "fddd6fafc182a2d6aa2dec6e273e605b21474474253b1c60999fc8195dd861c5"
];
export const LOCATIONS: ([[number, number], string] | null)[] = [
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"]
];